import type { FC } from "react"

import { ProfileEdit } from "./profile-edit"

export const Profile: FC = () => {
  return (<ProfileEdit />)
}
